import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Components
import ModalContainer from '../../containers/ModalContainer';
import { MainButton } from '../../../inputs/buttons/MainButton';
import { AlertIcon } from '../../../../assets/icons/AlertIcon';

// Styled Components
import {
  Container,
  IconContainer,
  Title,
  SummaryText,
  TabsList,
  TabItem,
  TabName,
  ErrorBadge,
  ArrowIcon,
  ButtonsContainer,
} from './styles';

// Types
import { ModalProps } from './types';

export const ValidationErrorsModal = ({
  onClickClose,
  tabsWithErrors,
  validationSummary,
  onNavigateToTab,
  ...props
}: ModalProps): JSX.Element => {
  const { t } = useTranslation(['modals', 'validation']);
  const theme = useTheme();

  const handleTabClick = (tabKey: string) => {
    onClickClose();
    onNavigateToTab(tabKey);
  };

  return (
    <ModalContainer
      width={50}
      fill={theme.colors?.black || '#000000'}
      onClickClose={onClickClose}
      title={t('modals:validationErrors.title', 'Errors de validació')}
    >
      <Container {...props}>
        <IconContainer>
          <AlertIcon />
        </IconContainer>

        <Title variant="semiBold">
          {t('modals:validationErrors.subtitle', 'No es pot guardar l\'actuació')}
        </Title>

        <SummaryText>
          {validationSummary || t('modals:validationErrors.defaultSummary', 'Hi ha camps obligatoris sense completar')}
        </SummaryText>

        <SummaryText size="S">
          {t('modals:validationErrors.clickToFix', 'Fes clic en una pestanya per anar-hi i corregir els errors:')}
        </SummaryText>

        <TabsList>
          {tabsWithErrors.map((tab) => (
            <TabItem
              key={tab.tabKey}
              onClick={() => handleTabClick(tab.tabKey)}
              type="button"
            >
              <TabName>{tab.tabLabel}</TabName>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <ErrorBadge>
                  {tab.errorCount} {tab.errorCount === 1
                    ? t('validation:error', 'error')
                    : t('validation:errorsPlural', 'errors')}
                </ErrorBadge>
                <ArrowIcon>&rarr;</ArrowIcon>
              </div>
            </TabItem>
          ))}
        </TabsList>

        <ButtonsContainer>
          <MainButton
            text={t('common:buttons.close', 'Tancar')}
            variant="secondary"
            onClick={onClickClose}
          />
        </ButtonsContainer>
      </Container>
    </ModalContainer>
  );
};
